import slice from "./registrationSlice";

export default slice.reducer;
